import { create } from 'zustand';

export interface Toast {
  id: string;
  message: string;
  variant: 'info' | 'success' | 'warn' | 'danger';
}

interface UiStore {
  toasts: Toast[];
  toast: (message: string, variant?: Toast['variant']) => void;
  dismiss: (id: string) => void;
}

export const useUiStore = create<UiStore>((set) => ({
  toasts: [],
  toast(message, variant = 'info') {
    const id = Math.random().toString(36).slice(2);
    set((s) => ({ toasts: [...s.toasts, { id, message, variant }] }));
    setTimeout(() => {
      set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) }));
    }, 4000);
  },
  dismiss(id) {
    set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) }));
  },
}));
